import { API_ENDPOINTS } from "../../../../Api/apiEndPoints"
import axiosInstance from "../../../../Api/axiosInstance";

export const getGeoDistaceList = async (params={})=>{

    let response = await axiosInstance.get(API_ENDPOINTS.GEO_DISTANCE.GET_GEO_DISTANCE_LIST,{params:params});
    const rowData = await response?.data;
    console.log("🚀 ~ getGeoDistaceList ~ rowData:", rowData)
    const formatedData = Array.isArray(rowData?.data?.data)
    ? rowData.data.data.map((item:any)=>({
        
        // TravelDocNeeded:item.TravelDocNeeded === false? "No" :"YES",
        TravelDocNeeded:item.TravelDocNeeded,

        GeoDistanceId:item.GeoDistanceId ||'-',
        BeltName:item?.BeltName || '-',

        FromStateName:item?.FromStateName || '-',
        FromStateId:item?.FromStateId ||'-',

        FromTownName:item?.FromTownName ||'-',
        FromTownId:item?.FromTownId ||'-',

        FromTownCity:item?.FromTownCity ||'-',
        ToTownCity:item?.ToTownCity ||'-',

        ToStateName:item?.ToStateName ||'-',
        ToStateId:item?.ToStateId ||'-',

        ToTownName:item?.ToTownName || '-',
        ToTownId:item?.ToTownId || '-',

        
        DistanceKm:item?.DistanceKm || '-',
        CalculationType:item?.CalculationType ||'-',
        Amount:item?.Amount ||'-',
        Remark:item?.Remark ||'-',
        Status:item?.Status === true ?'true' :'false'

        })) :[]
        // console.log('formatedData::',formatedData)
        return {rowData,formatedData}
} 

export const AddGeoDistace = async (ReqBody:any)=>{
     let url =`${API_ENDPOINTS.GEO_DISTANCE.POST_ADD_GEO_DISTANCE}` 
     const respnse = await axiosInstance.post(url,ReqBody);
}
export const getTownList = async (param:Record<string,any>)=>{
    let response = await axiosInstance.get(API_ENDPOINTS.GEO_DISTANCE.GET_GEO_TOWN_LIST,{params:param})
    const rowData  = await response?.data

    const formatedData = Array.isArray(rowData?.data?.data)?
    rowData?.data?.data.map((item:any)=>({
        id: item.id,
        label:item.label
    })) : []
    return {rowData,formatedData};
}


// This Function is Same as above but due to CustomDropdown we need to replicate
export const getTownList2 = async (params:{start:number,length:number,search:any})=>{
    let response = await axiosInstance.get(API_ENDPOINTS.GEO_DISTANCE.GET_GEO_TOWN_LIST_2,{params})
    const rowData  = await response?.data
    const formatedData = Array.isArray(rowData?.data?.data)?
    rowData?.data?.data.map((item:any)=>({
        id: item.id,
        label:item.label
    })) : []
    return {rowData,formatedData};
}

export const updateGeoDistance = async(ReqBody:any,id:number)=>{
   let url  = `${API_ENDPOINTS.GEO_DISTANCE.PUT_UPDATE_GEO_DISTANCE}/${id}`;
   const response = await axiosInstance.put(url,ReqBody);

}


export const getConfigStatus = async()=>{

    let response = await axiosInstance.get(API_ENDPOINTS.GEO_DISTANCE.GET_CONFIG_STATUS);
    const rowData = response.data;
    const CalculationType = Object.entries(rowData?.data.CalculationType || {}).map(([key,value])=>({
     id:key,
     label:String(value)
    }));

    const TravelDocNeeded = Object.entries(rowData?.data.TravelDocNeeded|| {}).map(([key,value])=>({
        id:key,
        label: String(value === "False" ? 'NO' :'YES')
    }));

    const Frequency = Object.entries(rowData?.data.Frequency).map(([key,value])=>({
        id:key,
        label:String(value)
    }))

    return{rowData,CalculationType,TravelDocNeeded,Frequency}
}
